import usePlayListStore from "../../stores/playlistStore";
import { PlaylistCardContainer, PlaylistTitle } from "./PlaylistCard.styled";
import { useState, useEffect } from "react";

const PlaylistCard = ({ playlistName, index, onClick }) => {
  const [background, setBackground] = useState(
    "https://neilpatel.com/wp-content/uploads/2017/08/colors.jpg"
  );
  const allPlaylists = usePlayListStore((state) => state.allPlaylists);
  const allVideos = Array.from(allPlaylists.values()).at(index);

  useEffect(() => {
    if (allVideos.length > 0) {
      setBackground(allVideos.at(0).thumbnailUrl);
    }
  }, [allVideos]);

  return (
    <PlaylistCardContainer background={background} onClick={onClick}>
      <PlaylistTitle>{playlistName}</PlaylistTitle>
    </PlaylistCardContainer>
  );
};

export default PlaylistCard;
